/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Gem_GuideInputs */

const en_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earn Time Crystals from Daily Focus Challenges, or get the Boosting Pack for an instant top-up.`)
};

const ar_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكسب بلورات الزمن من تحديات التركيز اليومية، أو احصل على حزمة التعزيز لإعادة شحن فورية.`)
};

const de_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdiene Time Crystals durch tägliche Fokus Herausforderungen, oder hol dir das Boosting-Paket für ein sofortiges Aufladen.`)
};

const es_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gana cristales de tiempo con los Desafíos de concentración diarios, u obtén el Pack de Impulso para una recarga instantánea.`)
};

const fr_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagne des Cristaux de temps grâce aux Défis de Concentration quotidiens, ou obtiens le Pack Booster pour un rechargement instantané.`)
};

const it_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guadagna Cristalli del Tempo dalle Sfide di Concentrazione quotidiane, o ottieni il Pacchetto Boost per una ricarica istantanea.`)
};

const ja_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日の集中チャレンジで時の結晶を獲得するか、ブーストパックで今すぐチャージしよう。`)
};

const ko_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매일 집중 챌린지로 타임 크리스탈을 모으거나, 부스팅 팩으로 즉시 충전하세요.`)
};

const pt_br_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhe Cristais do Tempo nos Desafios de Foco diários, ou adquira o Pacote Boost para recarga instantânea.`)
};

const ru_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарабатывай Кристальное Время в ежедневных Заданиях по фокусировке или получи Бустерный пакет для мгновенного пополнения.`)
};

const th_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สะสมคริสตัลแห่งกาลเวลาจากความท้าทายการโฟกัสประจำวัน หรือรับ Boosting Pack เพื่อเติมเต็มทันที`)
};

const tr_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük Odaklanma Mücadelelerinden Zaman Kristalleri kazan ya da anında dolum için Hızlandırma Paketini al.`)
};

const zh_cn_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成每日专注挑战，持续累积时光宝石。或选购加速礼包立刻加值！`)
};

const zh_tw_dialog_not_enough_gem_guide = /** @type {(inputs: Dialog_Not_Enough_Gem_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成每日專注挑戰，持續累積時光寶石。或選購加速禮包立刻加值！`)
};

/**
* | output |
* | --- |
* | "Earn Time Crystals from Daily Focus Challenges, or get the Boosting Pack for an instant top-up." |
*
* @param {Dialog_Not_Enough_Gem_GuideInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_gem_guide = /** @type {((inputs?: Dialog_Not_Enough_Gem_GuideInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Gem_GuideInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_gem_guide(inputs)
	if (locale === "ar") return ar_dialog_not_enough_gem_guide(inputs)
	if (locale === "de") return de_dialog_not_enough_gem_guide(inputs)
	if (locale === "es") return es_dialog_not_enough_gem_guide(inputs)
	if (locale === "fr") return fr_dialog_not_enough_gem_guide(inputs)
	if (locale === "it") return it_dialog_not_enough_gem_guide(inputs)
	if (locale === "ja") return ja_dialog_not_enough_gem_guide(inputs)
	if (locale === "ko") return ko_dialog_not_enough_gem_guide(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_gem_guide(inputs)
	if (locale === "ru") return ru_dialog_not_enough_gem_guide(inputs)
	if (locale === "th") return th_dialog_not_enough_gem_guide(inputs)
	if (locale === "tr") return tr_dialog_not_enough_gem_guide(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_gem_guide(inputs)
	return zh_tw_dialog_not_enough_gem_guide(inputs)
});